<template>
  <el-drawer
    :title="type === 1 ? '绑定动态令牌' : '换绑动态令牌'"
    :visible.sync="drawer"
    :modal-append-to-body="false"
    append-to-body
    destroy-on-close
    :wrapperClosable="false"
    size="100%"
    :custom-class="getClass()"
    @close="close"
  >
    <div class="container flex-center-column">
      <div class="step mb-88 flex-center">
        <div
          v-for="(item, index) in stepLists"
          :key="index"
          :style="{ width: index !== stepLists.length - 1 ? `${130 / stepLists.length - 1}%` : '72px' }"
          :class="{ 'ml-14': index == stepLists.length - 1 }"
          class="stepItem flex"
        >
          <div class="flex-center-column serial mr-14">
            <div class="serialNumber flex-center">
              <div class="bg" :class="{ 'active-bg': finishStep.includes(index) }"></div>
              <span class="text" :class="{ 'active-text': finishStep.includes(index) }">{{ index + 1 }}</span>
            </div>
            <div class="title" :class="{ 'active-title': finishStep.includes(index) }">{{ item }}</div>
          </div>
          <div v-if="index !== stepLists.length - 1" :class="{ 'active-bg': finishStep.includes(index) }" class="line"></div>
        </div>
      </div>
      <div class="content flex-center-column">
        <!-- 验证身份 -->
        <div v-if="stepLists[activeStep] === '验证身份'" class="step-content flex-center-column">
          <div class="title mb-64">您好，您正在更换绑定动态令牌，请完成手机号验证码身份验证</div>
          <el-form ref="form" :model="form" :rules="rules" status-icon size="small" label-width="93px" class="mb-161">
            <el-form-item label="手机号：" prop="mobilePhone">
              <el-input :disabled="!!USER_INFO.mobilePhone" v-angle="form.mobilePhone" v-model="form.mobilePhone" placeholder="填写手机号" class="mobilePhone" />
              <span class="getSmsCode" @click="getSms">{{ startCount ? `${smsCountDown}s` : codeText }}</span>
              <ETips background="transparent" padding="0" :marginTop="5" color="#666666" :iconWidth="12" :iconHeight="12" :left="8">
                <span v-if="!USER_INFO.mobilePhone">输入新增员工信息时录入的手机号，</span>
                点击右侧获取验证码
              </ETips>
            </el-form-item>
            <el-form-item label="验证码：" prop="smsCode">
              <el-input v-angle="form.smsCode" v-model="form.smsCode" :disabled="!form.mobilePhone" type="text" placeholder="填写验证码" />
            </el-form-item>
          </el-form>
        </div>
        <!-- 安装应用 -->
        <div v-if="stepLists[activeStep] === '安装应用'" class="step-content flex-center-column">
          <div class="title mb-64">您好，您的账号开启了动态令牌登录验证，请按照以下步骤完成绑定操作</div>
          <div class="title mb-32">请在手机下载并安装腾讯身份验证器</div>
          <div class="label mb-24">iPhone：在AppStore搜索腾讯身份验证器</div>
          <div class="label mb-10">安卓：请用微信扫码下载并安装腾讯身份验证器</div>
          <img src="@/assets/image/TencentAuthenticator.png" alt="" class="mb-10 TencentAuthenticator" />
          <ETips :marginBottom="32" text="选择‘普通下载’或取消勾选应用宝官方下载" />
          <div class="title mb-38">安装完成后点击下一步进入绑定页面（如已安装，直接进入下一步）</div>
        </div>
        <!-- 绑定动态令牌 -->
        <div v-if="stepLists[activeStep] === '绑定动态令牌'" class="step-content flex-center-column">
          <div class="title mb-32">使用腾讯身份验证器扫描以下二维码，获取6位动态令牌</div>
          <div v-loading="loading" class="qrBox mb-42">
            <img :src="ticketInfo.qrCode" alt="" class="qrCode mb-16" />
            <div class="label">Secret：{{ ticketInfo.key }}</div>
          </div>
          <el-input
            v-angle="dynamicToken"
            v-model="dynamicToken"
            placeholder="请输入6位数字的动态令牌"
            oninput="value=value.replace(/[^0-9]/g,'').slice(0,6)"
            class="mb-46"
            style="width: 220px; font-size: 14px"
          />
        </div>
        <!-- 完成 -->
        <div v-if="stepLists[activeStep] === '完成'" class="step-content flex-center-column">
          <img src="@/assets/image/success.png" alt="" class="success-icon mb-32" />
          <div class="title mb-16">绑定成功！</div>
          <div class="title mb-16">今后登录后台时需输入6位动态令牌，请不要卸载腾讯身份验证器</div>
          <div v-if="source == 1" class="finish-text">
            {{ countdown }}s后为您跳转物业帮帮首页，点击
            <span class="link" @click="jump">立即跳转</span>
          </div>
        </div>
        <el-button v-if="stepLists[activeStep] !== '完成'" size="small" type="primary" @click="next">下一步</el-button>
      </div>
    </div>
    <!--:imgs="vcodeIamges"-->
    <Vcode :show="showCode" @success="success" @close="showCode = false" style="z-index: 999999 !important" />
  </el-drawer>
</template>

<script>
import Vcode from 'vue-puzzle-vcode'
import { vcodeIamges } from '@/utils/file'
import { getOptTicket, checkOpt, getOptInfo, restOptInfo, optLogin, sendSmsCode } from '@/api/user'
export default {
  inject: ['securityCenterThis'],
  components: {
    Vcode,
  },
  props: {
    source: {
      type: Number,
      default: 1, //来源 1:nav 2:登录
    },
    ticket: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      vcodeIamges,
      type: 1, // 1：绑定，2：换绑
      showCode: false,
      activeStep: 0,
      drawer: false,
      secret: '',
      dynamicToken: '',
      countdown: 5,
      timer: null,
      form: {
        mobilePhone: '',
        smsCode: '',
      },
      ticket_1: '',
      rules: {
        mobilePhone: [
          { required: true, trigger: 'blur', message: '手机号不能为空' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur',
          },
        ],
        smsCode: [{ required: true, trigger: 'blur', message: '验证码不能为空' }],
      },
      ticketInfo: '', // 动态令牌信息
      loading: false,
      smsCountDown: 60, // 倒计时
      startCount: false,
      countdownInterval: null,
      codeText: '获取验证码',
      finishStep: [0],
    }
  },
  computed: {
    stepLists() {
      return this.type === 1 ? ['安装应用', '绑定动态令牌', '完成'] : ['验证身份', '安装应用', '绑定动态令牌', '完成']
    },
  },
  created() {
    this.form.mobilePhone = this.USER_INFO.mobilePhone
  },
  methods: {
    async next() {
      const limit = this.type === 1 ? 2 : 3
      if (this.stepLists[this.activeStep] === '验证身份') {
        const valid = await this.$refs.form.validate().catch(() => {})
        if (!valid) return
        const { data } = await restOptInfo({
          ticket: this.source === 2 ? this.ticket : '',
          smsCode: this.form.smsCode,
        })
        if (!data) return
        this.ticketInfo = data
      }
      if (this.stepLists[this.activeStep] === '安装应用') {
        this.getOptInfo()
      } else if (this.stepLists[this.activeStep] === '绑定动态令牌') {
        if (!this.dynamicToken) return this.$message.error('动态令牌不能为空')
        const res = await this.checkOpt()
        if (!res) return this.$message.error('动态令牌错误')
      }
      if (this.activeStep < limit) this.activeStep++
      if (!this.finishStep.includes(this.activeStep)) this.finishStep.push(this.activeStep)
      if (this.activeStep === limit) {
        if (this.source == 1) {
          this.countdown = 5
          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown === 0) {
              clearInterval(this.timer)
              this.jump()
            }
          }, 1000)
          this.$store.dispatch('user/getInfo')
        } else {
          this.dynamicTokenLogin()
        }
      }
    },

    // 令牌登录
    async dynamicTokenLogin() {
      const { data, errCode } = await optLogin({
        loginType: 1,
        code: this.dynamicToken,
        ticket: this.ticket,
      })
      if (errCode == 0) {
        this.securityCenterThis.loginInit(data.token)
        this.$message.success('动态令牌绑定成功，稍后为您跳转物业帮帮首页...')
      }
    },

    // 获取动态令牌
    async getTicket() {
      const { data } = await getOptTicket()
      return data
    },
    async getOptInfo() {
      this.loading = true
      this.ticket_1 = this.source === 1 ? await this.getTicket() : this.ticket
      const { data: res } = await getOptInfo({ ticket: this.ticket_1 })
      this.loading = false
      this.ticketInfo = res
    },

    // 校验动态令牌
    async checkOpt() {
      const { data } = await checkOpt({
        ticket: this.ticket_1,
        code: this.dynamicToken,
      })

      return data
    },

    // 跳转首页
    jump() {
      this.drawer = false
      this.securityCenterThis.drawer = false
      this.$router.replace('/welcome/welcome')
    },

    getSms() {
      this.$refs.form.validateField('mobilePhone', e => {
        if (!e) this.showCode = true
      })
    },

    // 获取验证码
    async success() {
      const res = await sendSmsCode({
        mobilePhone: this.form.mobilePhone,
      })
      if (!res) return this.$message.error(res.errMsg)
      this.$message.success('验证码发送成功')
      this.showCode = false
      this.smsCountDown = 60
      this.startCount = true
      this.startCountdown()
    },

    getClass() {
      if (this.source === 1) return this.sidebarIsOpen ? 'width210' : 'width54'
      return ''
    },

    // 验证码倒计时
    startCountdown() {
      this.countdownInterval && clearInterval(this.countdownInterval)
      this.countdownInterval = setInterval(() => {
        if (this.smsCountDown > 0) {
          this.smsCountDown--
        } else {
          this.startCount = false
          this.codeText = '重新获取验证码'
          clearInterval(this.countdownInterval)
        }
      }, 1000)
    },

    close() {
      this.securityCenterThis.show.showDynamicToken = false
      this.codeText = '获取验证码'
      clearInterval(this.timer)
      clearInterval(this.countdownInterval)
    },
  },
}
</script>

<style lang="less" scoped>
.mb-64 {
  margin-bottom: 64px;
}
.mb-32 {
  margin-bottom: 32px;
}
.mb-24 {
  margin-bottom: 24px;
}
.mb-88 {
  margin-bottom: 7.5%;
}
.mb-42 {
  margin-bottom: 42px;
}
.mb-38 {
  margin-bottom: 38px;
}
.mb-46 {
  margin-bottom: 46px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-16 {
  margin-bottom: 16px;
}
.mb-161 {
  margin-bottom: 30%;
}
.mr-14 {
  margin-right: 14px;
}
.flex-center-column {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.ml-14 {
  margin-left: 14px;
}
.step {
  width: 100%;
  .stepItem {
    .serialNumber {
      width: 36px;
      height: 36px;
      position: relative;
      margin-bottom: 8px;
      .bg {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        transform: rotate(45deg);
        border-radius: 10px;
        background: #f1f1f1;
      }
      .active-text {
        color: #ffffff !important;
      }
      .text {
        z-index: 1;
        font-size: 24px;
        font-weight: 500;
        color: #9e9e9e;
      }
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #9e9e9e;
    }
    .active-title {
      color: #31a8ff !important;
    }
    .line {
      height: 4px;
      flex: 1;
      margin-top: 16px;
      background-color: #f1f1f1;
    }
    .active-bg {
      background: #31a8ff !important;
    }
  }
}
.container {
  padding: 5.8% 15.8% 6.4%;
  .step {
    width: 100%;
  }
  .content {
    width: 100%;
    .TencentAuthenticator {
      width: 66px;
      height: 66px;
    }
    .title {
      color: #3d3d3d;
      font-size: 18px;
      font-weight: bold;
    }
    .label {
      color: #666666;
      font-size: 14px;
    }
    .qrBox {
      height: 222px;
      text-align: center;
    }
    .qrCode {
      width: 188px;
      height: 188px;
    }
    .success-icon {
      width: 88px;
      height: 88px;
    }
    .finish-text {
      color: #3d3d3d;
      font-size: 14px;
    }
    .link {
      font-size: 14px;
      cursor: pointer;
      color: #31a8ff;
    }
  }
  .mobilePhone {
    position: relative;
  }
  .getSmsCode {
    position: absolute;
    right: 25px;
    color: #31a8ff;
    cursor: pointer;
    top: 3%;
    font-size: 14px;
  }
  ::v-deep .mobilePhone .el-input__inner {
    padding: 0 100px 0 15px !important;
  }
  ::v-deep .el-input__inner {
    font-size: 14px !important;
    height: 40px !important;
  }
  ::v-deep .el-form-item__label {
    font-size: 14px !important;
    color: #666666 !important;
    text-align: start !important;
  }
}
</style>
